module.exports = __webpack_public_path__ + "static/media/orient.ef456e2b.png";